<documento [data]="data" (fecharModal)="fecharModal($event)" (abrirModalNegocio)="abrirModalNegocio($event)"></documento>